import React, { useState } from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import "../AreaPriceDetails/AreaPriceDetails.css";
import Base from "../admin_components/Admin_Base";
import Swal from "sweetalert2";
import authAxios from "../Auth/useAxios";

const GroupName = ["FUTURE_GREEN_CITY", "SAI_KESHAVA"];

const AddArea = () => {
  const [formData, setFormData] = useState({
    id: "",
    groupName: "",
    area: "",
    description: "",
    minimumAmount: "",
    percentage: "",
    percentageAmount: "",
    thirtyPercentageAmount: "",
    fullAmount: "",
    active: true,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const resetForm = () => {
    setFormData({
      groupName: "",
      area: "",
      description: "",
      minimumAmount: "",
      percentage: "",
      percentageAmount: "",
      thirtyPercentageAmount: "",
      fullAmount: "",
      active: true,
    });
  };

  const handleSubmit = async () => {
    if (!formData.groupName) {
      Swal.fire("Error", "Please select a Group Name.", "error");
      return;
    }
    if (!formData.area) {
      Swal.fire("Error", "Please enter an Area.", "error");
      return;
    }

    try {
      const response = await authAxios.post(`main/admin/add-area`, formData, {});
      console.log("Data posted successfully:", response.data);

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Area added successfully!",
      });

      resetForm();
    } catch (error) {
      console.error("Error posting data:", error.message);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong!",
      });
    }
  };

  return (
    <Base>
      <div className="container res_container">
        <div className="pt-3 mt-5 d-flex justify-content-end">
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
            className="admin_navigation"
          >
            <Link
              underline="hover"
              color="inherit"
              href="/admin/dashboard"
              sx={{ color: "darkslategrey", fontWeight: "bold" }}
            >
              Dashboard
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href="/admin/add_area"
              sx={{ color: "darkslategrey", fontWeight: "bold" }}
            >
              Add Area Price
            </Link>
          </Breadcrumbs>
        </div>

        <div>
          <h2 className="text-center fw-bold main_heading">Add Area Price Details</h2>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <hr style={{ width: "94%" }} />
          </div>

          <div className="form-group px-3 second_section mt-3">
            {/* Group Name */}
            <div className="row pb-3">
              <div className="col-sm-3 addarea_labels">
                <label className="col-form-label fw-bold">Group Name:</label>
              </div>
              <div className="col-sm-6 addarea_labels">
                <select
                  name="groupName"
                  className="form-control"
                  value={formData.groupName}
                  onChange={handleChange}
                  required
                >
                  <option value="">All Groups</option>
                  {GroupName.map((group, i) => (
                    <option key={i} value={group}>
                      {group}
                    </option>
                  ))}
                </select>
              </div>
            </div>

           

            {/* Area */}
            <div className="row pb-3">
              <div className="col-sm-3 addarea_labels">
                <label className="col-form-label fw-bold">Add Area:</label>
              </div>
              <div className="col-sm-6">
                <input
                  type="text"
                  name="area"
                  className="form-control"
                  value={formData.area}
                  onChange={handleChange}
                  placeholder="Enter area (e.g., 5 Guntas, 200 Square Yards)"
                  required
                />
              </div>
            </div>

            {/* Description */}
            <div className="row pb-3">
              <div className="col-sm-3 addarea_labels">
                <label className="col-form-label fw-bold">Description:</label>
              </div>
              <div className="col-sm-6">
                <textarea
                  name="description"
                  className="form-control"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Enter description"
                />
              </div>
            </div>

            {/* Minimum Amount */}
            <div className="row pb-3">
              <div className="col-sm-3 addarea_labels">
                <label className="col-form-label fw-bold">Minimum Amount:</label>
              </div>
              <div className="col-sm-6">
                <input
                  type="number"
                  name="minimumAmount"
                  className="form-control"
                  value={formData.minimumAmount}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Percentage */}
            <div className="row pb-3">
              <div className="col-sm-3 addarea_labels">
                <label className="col-form-label fw-bold">Percentage (%):</label>
              </div>
              <div className="col-sm-6">
                <input
                  type="number"
                  name="percentage"
                  className="form-control"
                  value={formData.percentage}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Percentage Amount */}
            <div className="row pb-3">
              <div className="col-sm-3 addarea_labels">
                <label className="col-form-label fw-bold">Percentage Amount:</label>
              </div>
              <div className="col-sm-6">
                <input
                  type="number"
                  name="percentageAmount"
                  className="form-control"
                  value={formData.percentageAmount}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* 30% Amount */}
            <div className="row pb-3">
              <div className="col-sm-3 addarea_labels">
                <label className="col-form-label fw-bold">30% Amount:</label>
              </div>
              <div className="col-sm-6">
                <input
                  type="number"
                  name="thirtyPercentageAmount"
                  className="form-control"
                  value={formData.thirtyPercentageAmount}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Full Amount */}
            <div className="row pb-3">
              <div className="col-sm-3 addarea_labels">
                <label className="col-form-label fw-bold">Full Amount:</label>
              </div>
              <div className="col-sm-6">
                <input
                  type="number"
                  name="fullAmount"
                  className="form-control"
                  value={formData.fullAmount}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Active */}
            <div className="row pb-3">
              <div className="col-sm-3 addarea_labels">
                <label className="col-form-label fw-bold">Active:</label>
              </div>
              <div className="col-sm-6">
                <input
                  type="checkbox"
                  name="active"
                  checked={formData.active}
                  onChange={handleChange}
                />{" "}
                Active
              </div>
            </div>

            {/* Submit */}
            <div className="d-flex justify-content-center">
              <button
                type="button"
                className="btn admin_btn"
                onClick={handleSubmit}
              >
                Add Area
              </button>
            </div>
          </div>
        </div>
      </div>
    </Base>
  );
};

export default AddArea;
